import React from 'react'

const QuestionRow = ({ label, value, staticField = false, policyAddressInfo }) => {
    return (
        <div className="col-12">
            <div className="row my-3 ms-sm-5">
                <div className="col-12 col-md-6 text-primary fw-bold mb-2 mb-md-0">
                    {label}
                </div>
                <div className="col-12 col-md-6 col-sm-8 fw-bold">
                    {!staticField ? (
                        <label>{value}</label>
                    )
                        :
                        (
                            <label>
                                {policyAddressInfo?.homeAddress} {policyAddressInfo?.aptNumber}<br />
                                {`${policyAddressInfo?.city}, ${policyAddressInfo?.state + " " + policyAddressInfo?.zip?.substring(0, 5)}`}
                            </label>
                        )
                    }
                </div>

            </div>
        </div>
    )
}

export default QuestionRow